import React from "react";
import LandmarkLogo from "../LandmarkLogo";
import { Headshot } from "./shared";

// Full forest background, oversized circular headshot, large sans type.
export default function BoldBlock({ data, headshot }) {
  const name = data.name || "New Hire";
  return (
    <div className="wp-canvas wp-t-bold">
      <div className="wp-t-bold__ring wp-t-bold__ring--a" />
      <div className="wp-t-bold__ring wp-t-bold__ring--b" />

      <header className="wp-t-bold__top">
        <LandmarkLogo width={230} />
        {data.team && <div className="wp-t-bold__team">{data.team}</div>}
      </header>

      <Headshot headshot={headshot} className="wp-t-bold__photo" />

      <div className="wp-t-bold__copy">
        <p className="wp-t-bold__eyebrow">{data.tagline || "Welcome to the team"}</p>
        <h1>{name}</h1>
        {data.role && <p className="wp-t-bold__role">{data.role}</p>}
      </div>

      <footer className="wp-t-bold__footer">
        <span>landmarkventures.com</span>
        {data.note && <span className="wp-t-bold__note">{data.note}</span>}
      </footer>
    </div>
  );
}
